import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { marked } from 'marked';
import hljs from 'highlight.js';

@Component({
    selector: 'phito-markdown',
    standalone: true,
    templateUrl: './markdown.component.html',
    styleUrl: './markdown.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarkdownComponent {
    sanitizer = inject(DomSanitizer);

    markdown = input<string>('');
    rendered = computed(() => this.renderMarkdown(this.markdown()));

    constructor() {
        const renderer = new marked.Renderer();

        // Marked expects: ({ text, lang, escaped }) => string
        renderer.code = ({ text, lang }: { text: string; lang?: string; escaped?: boolean }) => {
            const language = (lang || '').trim().toLowerCase();

            const highlighted =
                language && hljs.getLanguage(language)
                    ? hljs.highlight(text, { language }).value
                    : hljs.highlightAuto(text).value;

            const cls = language ? `language-${language}` : '';
            return `<pre><code class="hljs ${cls}">${highlighted}</code></pre>`;
        };

        marked.setOptions({
            gfm: true,
            breaks: false,
            headerIds: true,
            mangle: false,
            renderer,
        } as any);
    }

    private renderMarkdown(md: string): SafeHtml {
        const html = marked.parse(md || '') as string;
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}
